import { createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import ChallengePage from './components/Pages/ChallengePage.vue';
import Signup from './components/Signup/Signup.vue';
import LoginEnterPhoneNumber from './components/Login/LoginEnterPhoneNumber.vue';
import LoginEnterCode from './components/Login/LoginEnterCode.vue';
import { isLoggedIn } from './api/loginApi';
import { useSessionStore } from './stores/session';
import Segment from './Segment';
import RemoveParticipant from './components/RemoveParticipant/RemoveParticipant.vue';
import AsyncLoadingWrapper from './components/Common/AsyncLoadingWrapper.vue';
import ChallengeVisitorIntro from './components/ChallengeVisitorIntro/ChallengeVisitorIntro.vue';

const routes = [
  {
    path: '/',
    name: 'ChallengeRoutes',
    component: AsyncLoadingWrapper,
    beforeEnter: _authenticateOrRedirectToIntro,
    children: [
      {
        path: 'challenges/:challengeId',
        component: ChallengePage,
      },
    ],
  },
  {
    path: '/',
    name: 'AuthenticatedRoutes',
    component: AsyncLoadingWrapper,
    beforeEnter: _authenticateOrRedirectToLogin,
    children: [
      {
        path: 'remove-from-challenge/:challengeId',
        component: RemoveParticipant,
      },
    ],
  },
  {
    path: '/',
    name: 'UnAuthenticatedRoutes',
    component: AsyncLoadingWrapper,
    children: [
      {
        path: 'login',
        component: LoginEnterPhoneNumber,
      },
      {
        path: 'login-enter-code',
        component: LoginEnterCode,
      },
      {
        path: 'signup',
        component: Signup,
      },
      {
        path: 'intro/:challengeId',
        component: ChallengeVisitorIntro,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

async function _authenticateOrRedirectToIntro(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> {
  const isAuthenticated = await _isAuthenticated();
  if (isAuthenticated) {
    Segment.trackUserGot('LoggedIn', { path: to.path });
    return next();
  }
  Segment.trackUserGot('NotLoggerIn', { path: to.path });
  const queryParams = _queryWithRedirectUrl(to);
  const { challengeId } = to.params;
  return next({
    path: `/intro/${challengeId}`,
    query: queryParams,
  });
}

async function _authenticateOrRedirectToLogin(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> {
  const isAuthenticated = await _isAuthenticated();
  if (isAuthenticated) {
    Segment.trackUserGot('LoggedIn', { path: to.path });
    return next();
  }
  Segment.trackUserGot('NotLoggerIn', { path: to.path });
  const queryParams = _queryWithRedirectUrl(to);

  return next({
    path: '/login',
    query: queryParams,
  });
}
function _queryWithRedirectUrl(to: RouteLocationNormalized) {
  // Removing the first / from the path to make sure the path is not empty
  const cleanToPath = to.path.replace('/', '');
  return cleanToPath === '' ? { ...to.query } : { ...to.query, redirectTo: encodeURIComponent(to.path) };
}

async function _isAuthenticated(): Promise<boolean> {
  const sessionStore = useSessionStore();
  if (sessionStore.memberId) {
    return true;
  }
  const loggedIn = await isLoggedIn();
  if (loggedIn) {
    await sessionStore.init();
    return true;
  }
  return false;
}

export default router;
